import { NoticeInfoEntity } from "@/domain/entity/notice/notice-info-entity";
import { NoticeRepository } from "@/domain/repository/notice-repository";
import { SATError, SATResult } from "@sadtx/sat-error";

export class FetchNoticeListUsecase {
  constructor(private readonly noticeRepository: NoticeRepository) {}

  async execute(): Promise<SATResult<NoticeInfoEntity[], SATError>> {
    const result = await this.noticeRepository.fetchNoticeList();

    if (result.isSuccess) {
      const sortedList = result.value?.sort((a, b) => {
        return (
          new Date(b.publishPeriod.start).getTime() - new Date(a.publishPeriod.start).getTime()
        );
      });
      console.log("[FetchNoticeListUsecase] :: execute :: 공지사항 목록 조회 성공", sortedList);
      return SATResult.success(sortedList || []);
    }

    console.log("[FetchNoticeListUsecase] :: execute :: 공지사항 목록 조회 실패", result.error);
    return SATResult.failure(result.error);
  }
}
